<template>
  <modal
    name="plateValidationModal"
    :width="'800px'"
    :height="'auto'"
    :scrollable="true"
    :adaptive="true"
    :transition="''"
    :class="'validationsModal'"
  >
    <div class="validation-wrapper">

      <header class="validation-header">
        <h3 class="title">
          {{$t('ver_validacoes')}}
        </h3>
        <span class="validation-count" v-if="validations.length > 0">
          {{ validations.length }}
        </span>
      </header>

      <div v-if="validations.length === 0" class="no-validations">
        {{$t('sem_validacoes')}}
      </div>

      <ul v-else class="validation-list">
        <li v-for="(val, index) in validations" :key="index" class="validation-item">
          <i class="fas fa-exclamation-triangle warning-icon"></i>
          <span>{{ val }}</span>
        </li>
      </ul>

      <div class="button-row">
        <button class="button ghost" @click="$modal.hide('plateValidationModal')">
          <i class="fas fa-times"></i> {{$t('Fechar')}}
        </button>
      </div>

    </div>
  </modal>
</template>
<script>
export default {
  name: "PlateValidationModal",
  props: {
    validations: {
      type: Array,
      default: () => []
    },
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.validationsModal {
  z-index: 999 !important;
}

.validation-wrapper {
  padding: 14px;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(244, 247, 255, 0.55) 0%, #ffffff 24%);
}

.validation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid rgba(33, 33, 70, 0.14);
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.title {
  margin: 0;
  text-align: left;
  font-size: 1.02rem;
  font-weight: 700;
  color: #1f2b56;
}

.validation-count {
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(215, 38, 61, 0.12);
  color: #c11937;
  font-weight: 800;
  font-size: 0.82rem;
}

.validation-list {
  list-style: none;
  margin: 0;
  padding: 0;

  max-height: 360px;
  overflow-y: auto;
  border: 1px solid rgba(33, 33, 70, 0.12);
  border-radius: 10px;
  padding: 8px;
  background: #fbfcff;

  .validation-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 0.86rem;
    line-height: 1.35;
    color: #202f62;
    border: 1px solid rgba(33, 33, 70, 0.1);
    background: #ffffff;
    border-radius: 8px;
    padding: 8px 9px;
    margin-bottom: 7px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

.warning-icon {
  color: #d7263d;
  font-size: 0.95rem;
  margin-top: 2px;
  flex-shrink: 0;
}

.no-validations {
  padding: 20px 14px;
  text-align: center;
  border: 1px dashed rgba(33, 33, 70, 0.25);
  border-radius: 10px;
  background: #f9fbff;
  color: #4d5d8d;
  font-weight: 600;
  font-size: 0.88rem;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  border-top: 1px solid rgba(33, 33, 70, 0.1);
  padding-top: 10px;
}

.button {
  min-width: 120px;
  padding: 7px 15px;
  margin-left: 5px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.82rem;
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #d7263d;
  border: 1px solid rgba(215, 38, 61, 0.7);

  &:hover {
    color: #212146;
    border-color: #212146;
  }
}

@media screen and (max-width: 760px) {
  .validation-wrapper {
    padding: 12px;
  }

  .validation-list {
    max-height: 300px;
  }

  .button {
    min-width: 100%;
    margin-left: 0;
  }
}
</style>
